import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import AppLink from 'FormsUI/components/common/AppLink';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { getQuarantineUrl, getSpamSubmissionsUrl } from 'FormsUI/lib/RouteGenerators';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { isUngatedForSpamSubmissionsCodeOrange } from '../../../../selectors/Gates';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SpamSubmissionsCell({
  crmObject
}) {
  const isSpamSubmissionUpdatesEnabled = useSelector(isUngatedForSpamSubmissionsCodeOrange);
  const propertyValue = getPropertyValue(crmObject, PROPERTIES.SPAM_SUBMISSIONS);
  const submissionsCount = Number(propertyValue);
  const formId = getPropertyValue(crmObject, PROPERTIES.FORM_ID);
  const href = isSpamSubmissionUpdatesEnabled ? getSpamSubmissionsUrl(formId) : getQuarantineUrl(formId);
  return submissionsCount ? /*#__PURE__*/_jsxs(AppLink, {
    href: href,
    use: "blue",
    onClick: () => trackDashboardInteraction('go-to-submissions-spam-column'),
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.frameworkTable.columns.spamSubmissions.tooltip"
      }),
      children: /*#__PURE__*/_jsx(WarningIcon, {
        size: "300"
      })
    }), /*#__PURE__*/_jsx(FormattedNumber, {
      value: submissionsCount || 0,
      abbreviate: true
    })]
  }) : /*#__PURE__*/_jsx(FormattedNumber, {
    value: 0
  });
}
export const spamSubmissions = {
  width: 160,
  multiline: true,
  renderCell: props => /*#__PURE__*/_jsx(SpamSubmissionsCell, Object.assign({}, props))
};